import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ModalController, LoadingController} from '@ionic/angular';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { Sale } from '../../../models/sale/sale.model';
import { Stylist } from '../../../models/stylist/stylist.model';
import { Payment } from '../../../models/payment/payment.model';
import { Utilities } from '../../../utilities/utilities';
import { UserService } from '../../../services/user.service';
import { TerminalConnectionPageCallback } from '../terminal-connection/terminal-connection.page';
import { TerminalConnectionPage } from '../terminal-connection/terminal-connection.page';
import { MaskitoOptions, MaskitoElementPredicateAsync } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
declare var posthog: any;
export interface SalePaymentformModalCallBackData {
  payment: Payment,
  tips?: number,
  tipsForStylist?: Stylist,
  action: string,
  cashRounding: number
}

@Component({
  selector: 'app-sale-payment-form',
  templateUrl: './sale-payment-form.page.html',
  styleUrls: ['./sale-payment-form.page.scss'],
})
export class SalePaymentFormPage implements OnInit {

  @Input() sale: Sale;

  @Input() payment: Payment;

  @Input() paymentIndex: number;

  public paymentForm: UntypedFormGroup;

  public paymentField : UntypedFormControl;

  @Input() showRemoveButton: boolean;

  public pennyRounding: boolean;

  public pennyRoundedCashBalance: number;

  public penny: number;

  currency: string;
  currencyMask: MaskitoOptions;

  readonly maskPredicate: MaskitoElementPredicateAsync = async (el) =>
    (el as HTMLIonInputElement).getInputElement();
  public submitted: boolean;

  public saleTotalToBeDisplayed: number;

  constructor (
              //private navParams: NavParams,
              private userService: UserService,
              //private viewCtrl: ViewController,
              private modalController: ModalController,
              private loadingCtrl: LoadingController,
              private formBuilder: UntypedFormBuilder) {
   // this.sale = this.navParams.get('sale');
   // this.payment = this.navParams.get('payment');
   // this.paymentIndex = this.navParams.get('paymentIndex');
      
  }

  public ngOnInit () {
    this.saleTotalToBeDisplayed = this.sale.balance;
       // check if the payment type is a cash
      if (this.payment.type === 1) {
        this.pennyRounding =  true;
  
        // let totalCashPayments: number = 0;
        // this.sale.payments.forEach((payment: Payment) => {
        //   if (payment.type === 1) {
        //     totalCashPayments += payment.amount;
        //   }
        // });
  
        // let cashNeededToCloseThisSale: number = this.sale.balance + totalCashPayments;
        let cashNeededToCloseThisSale: number = this.sale.balance;
        this.pennyRoundedCashBalance = Utilities.pennyRounding(cashNeededToCloseThisSale);
        this.penny = this.pennyRoundedCashBalance - cashNeededToCloseThisSale;
        // this.sale = this.sale.setCashRounding(this.penny);
  
        this.saleTotalToBeDisplayed = Utilities.pennyRounding(this.sale.balance);
      }
  
      // check if we're adding a new payment to the sale
      if (this.paymentIndex === -1) {
  
        // Auto-fill the payment with the sale's balance
        this.payment = this.payment.setAmount(this.sale.balance);
  
        // check if the payment type is a cash
        if (this.payment.type === 1) {
  
          // Do penny rounding
          this.payment = this.payment.setAmount(this.pennyRoundedCashBalance);
        }
  
        this.sale = this.sale.addPayment(this.payment);
        this.paymentIndex = this.sale.getPayments().count() - 1;
      }
    //this.showRemoveButton = this.navParams.get('showRemoveButton');
    this.paymentField = new UntypedFormControl(Utilities.roundTo2Decimal(this.payment.amount).toFixed(2), Validators.compose([Validators.required]));
    this.paymentForm = this.formBuilder.group({
      payment: this.paymentField
    });

    this.currency = Utilities.decodeHTML(
      this.userService.getSalon().getCurrency()
    );

    this.currencyMask = maskitoNumberOptionsGenerator({
      decimalZeroPadding: true,
      precision: 2,
      decimalSeparator: '.',
      thousandSeparator: ',',
      min: 0,
      prefix: this.currency,
    });
  }

  public onDismiss () {
   // this.viewCtrl.dismiss();
   this.modalController.dismiss();
   
  }

  public updatePayment (event) {
    const amount: number = Utilities.extractNumberFromString(this.paymentField.value);
    posthog.capture('Payment Added', { amount: amount });
    this.sale = this.sale.updatePayment(this.paymentIndex, this.payment.setAmount(amount))
  }

  public justSave () {

    this.submitted = true;

    if (!this.paymentForm.valid) {
      return;
    }


    // if (this.payment.type === 1) {
    //   const pennyRoundedValue: number = Utilities.pennyRounding(this.payment.amount);

    //   if (this.payment.amount !== pennyRoundedValue) {
    //     return;
    //   }

    // }

    // const amount: number = Utilities.roundTo2Decimal(this.paymentField.value);
    const amount: number = Utilities.extractNumberFromString(this.paymentField.value);
    const data: SalePaymentformModalCallBackData = {
      payment: this.payment.setAmount(amount),
      action: 'save',
      cashRounding: this.pennyRounding && this.sale.isSaleReadyForCheckOut() ? this.penny : 0
    };
    //this.viewCtrl.dismiss(data);
    this.modalController.dismiss(data);
  }

  public async charge () {

    this.submitted = true;

    if (!this.paymentForm.valid) {
      return;
    }

    const modal = await this.modalController.create({
      component: TerminalConnectionPage,
      componentProps: {
      sale: this.sale,
      payment: this.payment
    },
    backdropDismiss: false
    
  });
    modal.onDidDismiss().then((response: any) => {

      if (response) {
        // const amount: number = Utilities.extractNumberFromString(this.paymentField.value);
        const amount: number = response.payment;
        const data: SalePaymentformModalCallBackData = {
          payment: this.payment.setAmount(amount),
          tips: response.calculatedTipValue,
          tipsForStylist: response.tipsForStylist,
          action: 'save',
          cashRounding: this.pennyRounding && this.sale.isSaleReadyForCheckOut() ? this.penny : 0
        };
        //this.viewCtrl.dismiss(data);
        this.modalController.dismiss(data);
      }

    });
    await modal.present();
  }

  public remove () {
    const data: SalePaymentformModalCallBackData = {
      payment: this.payment,
      action: 'remove',
      cashRounding: 0
    };

    //this.viewCtrl.dismiss(data);
    this.modalController.dismiss(data);
  }

  public isPaymentTypeChargeable () : boolean {

    return (
      // Debit
      this.payment.type === 2  ||

      // Visa
      this.payment.type === 3 ||

      // Mastercard
      this.payment.type === 4 ||

      // AMEX
      this.payment.type === 5);
         
  }

}
